(function () {
  var SECTION_SELECTOR = '.oddit-section-main-product';

  function initSection(section) {
    if (!section) return;

    /* ---------- Thumbnails → main gallery nav ---------- */
    var mainCarousel = section.querySelector('.oddit-section-main-product__main-carousel');
    var mainSlides = mainCarousel
      ? Array.prototype.slice.call(mainCarousel.children)
      : [];

    /* Desktop hides every .main-slide via CSS and only shows .main-image,
       so vertical-thumb clicks swap the .main-image's <img> attrs to the
       chosen slide. Snapshot every slide's image attrs once so index 0
       (the live .main-image) can be restored. */
    var mainImageEl = section.querySelector('.oddit-section-main-product__main-image');
    var mainImageImg = mainImageEl && mainImageEl.querySelector('img.oddit-section-main-product__main-image-img');
    var slideImageAttrs = mainSlides.map(function (slide) {
      var img = slide.querySelector('img.oddit-section-main-product__main-image-img');
      if (!img) return null;
      return {
        src: img.getAttribute('src') || '',
        srcset: img.getAttribute('srcset') || '',
        sizes: img.getAttribute('sizes') || '',
        alt: img.getAttribute('alt') || '',
        width: img.getAttribute('width') || '',
        height: img.getAttribute('height') || ''
      };
    });

    var mediaTypes = mainSlides.map(function (slide) {
      return slide.getAttribute('data-media-type') || 'image';
    });

    function isVideoMedia(idx) {
      return mediaTypes[idx] === 'video' || mediaTypes[idx] === 'external_video';
    }

    var firstIsVideo = mediaTypes.length > 0 && isVideoMedia(0);

    function pauseVideosExcept(keepIdx) {
      mainSlides.forEach(function (slide, i) {
        if (i === keepIdx) return;
        var video = slide.querySelector('video');
        if (video && typeof video.pause === 'function') video.pause();
      });
    }

    function playVideoAt(idx) {
      var slide = mainSlides[idx];
      if (!slide) return;
      var video = slide.querySelector('video');
      if (!video || typeof video.play !== 'function') return;
      video.muted = true;
      var played = video.play();
      if (played && typeof played.catch === 'function') played.catch(function () {});
    }

    function syncVideoPlayback(idx) {
      pauseVideosExcept(idx);
      if (isVideoMedia(idx)) playVideoAt(idx);
    }

    function setDesktopMedia(idx) {
      var slideMode = idx !== 0 && (isVideoMedia(idx) || firstIsVideo);
      mainSlides.forEach(function (slide, i) {
        if (i === 0) return;
        slide.classList.toggle('is-media-active', slideMode && i === idx);
      });
      if (mainImageEl) mainImageEl.classList.toggle('is-media-hidden', slideMode);
      if (!slideMode && !firstIsVideo) swapMainImage(idx);
    }

    function swapMainImage(idx) {
      if (!mainImageImg) return;
      var attrs = slideImageAttrs[idx];
      if (!attrs) return;
      if (attrs.srcset) mainImageImg.setAttribute('srcset', attrs.srcset);
      else mainImageImg.removeAttribute('srcset');
      if (attrs.sizes) mainImageImg.setAttribute('sizes', attrs.sizes);
      else mainImageImg.removeAttribute('sizes');
      if (attrs.width) mainImageImg.setAttribute('width', attrs.width);
      if (attrs.height) mainImageImg.setAttribute('height', attrs.height);
      mainImageImg.setAttribute('alt', attrs.alt);
      /* set src last so the new srcset is in place before the browser picks */
      mainImageImg.setAttribute('src', attrs.src);
      /* Caption + gradient overlay are first-image-only */
      if (mainImageEl) {
        mainImageEl.classList.toggle('is-caption-hidden', idx !== 0);
      }
    }

    function slideStep() {
      if (mainSlides.length > 1) {
        return mainSlides[1].offsetLeft - mainSlides[0].offsetLeft;
      }
      return mainSlides.length ? mainSlides[0].offsetWidth : 0;
    }

    /* Both thumb strips share the same active index so they stay in sync
       (e.g. after a resize that swaps which strip is visible). */
    var activeIdx = 0;
    var thumbGroups = [];

    function setActiveAll(idx) {
      var changed = idx !== activeIdx;
      activeIdx = idx;
      thumbGroups.forEach(function (group) {
        group.thumbs.forEach(function (t, i) {
          t.classList.toggle('oddit-section-main-product__thumbnail--active', i === idx);
        });
      });
      if (changed) syncVideoPlayback(idx);
    }

    function wireThumbs(groupSelector, syncWithCarousel) {
      var group = section.querySelector(groupSelector);
      if (!group) return;
      var thumbs = group.querySelectorAll('.oddit-section-main-product__thumbnail');
      if (!thumbs.length) return;

      thumbGroups.push({ group: group, thumbs: thumbs });

      /* While a click-initiated smooth scroll is animating, ignore the
         intermediate scroll events so the active thumb doesn't flicker
         across every slide it passes. */
      var syncLocked = false;
      var unlockTimer;
      function lockSync() {
        syncLocked = true;
        clearTimeout(unlockTimer);
        unlockTimer = setTimeout(function () { syncLocked = false; }, 700);
      }
      function unlockSync() {
        syncLocked = false;
        clearTimeout(unlockTimer);
      }

      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () {
          setActiveAll(i);
          if (syncWithCarousel && mainCarousel && mainSlides[i]) {
            /* Mobile: scroll the carousel; the .main-image element stays
               as slot 0 so don't mutate its image. */
            lockSync();
            var base = mainSlides[0].offsetLeft;
            mainCarousel.scrollTo({
              left: mainSlides[i].offsetLeft - base,
              behavior: 'smooth'
            });
          } else {
            /* Desktop: .main-slide is display:none, so swap the visible
               .main-image's img attrs to render the chosen slide. */
            setDesktopMedia(i);
            syncVideoPlayback(i);
          }
        });
      });

      if (syncWithCarousel && mainCarousel && mainSlides.length) {
        mainCarousel.addEventListener('scroll', function () {
          if (syncLocked) return;
          var step = slideStep() || 1;
          var idx = Math.round(mainCarousel.scrollLeft / step);
          idx = Math.max(0, Math.min(idx, thumbs.length - 1));
          setActiveAll(idx);
        });
        mainCarousel.addEventListener('scrollend', unlockSync);
      }
    }

    wireThumbs('.oddit-section-main-product__thumbnails-horizontal', true);
    wireThumbs('.oddit-section-main-product__thumbnails-vertical', false);

    /* ---------- Step accordions ----------
       Click anywhere on the header collapses/expands the step. The step-link
       anchor (helper link) and any other anchors keep their normal behavior. */
    var steps = section.querySelectorAll('.oddit-section-main-product__step');
    steps.forEach(function (step) {
      var header = step.querySelector('.oddit-section-main-product__step-header');
      var toggle = step.querySelector('.oddit-section-main-product__step-toggle');
      if (!header) return;

      function setCollapsed(collapsed) {
        step.classList.toggle('is-collapsed', collapsed);
        if (toggle) toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      }

      header.addEventListener('click', function (e) {
        /* Skip clicks on the helper link/button so they don't also toggle the step */
        if (e.target.closest('a, [data-step2-help-trigger], [data-step3-compare-trigger]')) return;
        setCollapsed(!step.classList.contains('is-collapsed'));
      });
    });

    /* ---------- "My Selections" → Edit link → jump to the matching step ----------
       Anchor hrefs (#step-1 / #step-2 / #step-3) keep the no-JS jump working;
       this handler upgrades that to a smooth scroll and expands the step if it
       was collapsed, so the user lands on something they can actually edit. */
    section.querySelectorAll('.oddit-section-main-product__selections-edit').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var href = link.getAttribute('href') || '';
        if (href.charAt(0) !== '#' || href.length < 2) return;
        var target = section.querySelector(href);
        if (!target) return;
        e.preventDefault();
        if (target.classList.contains('is-collapsed')) {
          target.classList.remove('is-collapsed');
          var toggle = target.querySelector('.oddit-section-main-product__step-toggle');
          if (toggle) toggle.setAttribute('aria-expanded', 'true');
        }
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });

        target.classList.remove('is-edit-flash');
        // eslint-disable-next-line no-unused-expressions
        void target.offsetWidth;
        target.classList.add('is-edit-flash');
        setTimeout(function () {
          target.classList.remove('is-edit-flash');
        }, 1200);
      });
    });

    /* ---------- Color tab click → activate + filter swatches ----------
       Tabs carry `data-color-filter` (empty = show all). Swatches carry
       `data-base-color`. Match is exact + case-insensitive. */
    var colorTabs = section.querySelectorAll('.oddit-section-main-product__color-tab');
    var allSwatches = section.querySelectorAll('.oddit-section-main-product__color-swatch');
    colorTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        colorTabs.forEach(function (t) {
          t.classList.remove('oddit-section-main-product__color-tab--active');
        });
        tab.classList.add('oddit-section-main-product__color-tab--active');

        var filter = (tab.getAttribute('data-color-filter') || '').toLowerCase();
        allSwatches.forEach(function (sw) {
          var base = (sw.getAttribute('data-base-color') || '').toLowerCase();
          var show = !filter || !base || base === filter;
          sw.hidden = !show;
        });
      });
    });

    /* ---------- Color swatch click → activate ----------
       Swatches are <a> links that navigate to the chosen color's product
       page; the new page renders with that color's data. We just toggle
       the visual active state for the moment before navigation. */
    var swatches = section.querySelectorAll('.oddit-section-main-product__color-swatch');
    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        swatches.forEach(function (s) {
          s.classList.remove('oddit-section-main-product__color-swatch--active');
        });
        swatch.classList.add('oddit-section-main-product__color-swatch--active');
      });
    });

    /* ---------- Variant pickers (length & thickness) ----------
       Single source of truth: a JSON block lists every variant with its
       full options array, availability, and price. We track the current
       option selection in `currentOptions` and look up the matching
       variant on every click. That way length × thickness cross-option
       changes always resolve to the right variant — no stale combos. */
    var dataEl = section.querySelector('[data-mainproduct-variant-data]');
    var variantData = null;
    try { if (dataEl) variantData = JSON.parse(dataEl.textContent); } catch (e) { variantData = null; }
    var variants = (variantData && variantData.variants) || [];
    var lengthIdx = variantData && typeof variantData.lengthIndex === 'number' ? variantData.lengthIndex : -1;
    var thicknessIdx = variantData && typeof variantData.thicknessIndex === 'number' ? variantData.thicknessIndex : -1;

    var atcButton = section.querySelector('[data-add-to-cart]');
    var atcLabel = atcButton ? atcButton.querySelector('[data-button-label]') : null;
    var ctaLabelText = atcButton ? atcButton.getAttribute('data-cta-label') || 'Add to cart' : '';
    var ctaSoldOutText = atcButton ? atcButton.getAttribute('data-cta-sold-out-label') || 'Sold out' : '';

    var initialId = variantData ? variantData.initialVariantId : (atcButton ? Number(atcButton.getAttribute('data-variant-id')) : null);
    var initialVariant = variants.filter(function (v) { return v.id === initialId; })[0];
    var currentOptions = initialVariant ? initialVariant.options.slice() : [];

    function lookupVariant() {
      if (!currentOptions.length) return null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < v.options.length; j++) {
          if (v.options[j] !== currentOptions[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function updatePrice(price) {
      if (!price) return;
      /* Re-query each call because the ATC's price span gets recreated on
         every label rebuild. Trusted Liquid output, so innerHTML is OK. */
      section.querySelectorAll('[data-price-display]').forEach(function (el) {
        el.innerHTML = price;
      });
    }

    /* null compareAtPrice means this variant isn't on sale -> hide the slash. */
    function updateCompare(compare) {
      section.querySelectorAll('[data-price-compare]').forEach(function (el) {
        var amountEl = el.querySelector('[data-price-compare-amount]');
        if (amountEl) amountEl.innerHTML = compare || '';
        el.hidden = !compare;
      });
    }

    var bisButton = section.querySelector('[data-bis-trigger]');
    function setBisState(available, variantId) {
      if (!bisButton) return;
      if (available) {
        bisButton.hidden = true;
      } else {
        bisButton.hidden = false;
        bisButton.setAttribute('data-variant-id', variantId ? String(variantId) : '');
      }
    }

    function applyVariantToUi() {
      var variant = lookupVariant();
      if (!atcButton || !atcLabel) return;

      if (variant) {
        atcButton.setAttribute('data-variant-id', String(variant.id));
        /* Price/compare update outside the availability branch: a sold-out
           variant still has a price, and leaving the previous variant's
           figures on screen was showing a stale (and possibly stale-sale)
           price. */
        updatePrice(variant.price);
        updateCompare(variant.compareAtPrice);
        if (variant.available) {
          atcButton.disabled = false;
          atcButton.removeAttribute('disabled');
          atcLabel.innerHTML = ctaLabelText +
            '&nbsp;&nbsp;&bull;&nbsp;&nbsp;<span data-price-display>' + variant.price + '</span>';
          setBisState(true, variant.id);
        } else {
          atcButton.disabled = true;
          atcLabel.textContent = ctaSoldOutText;
          setBisState(false, variant.id);
        }
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      } else {
        /* No variant matches the current combination → sold out */
        atcButton.disabled = true;
        atcLabel.textContent = ctaSoldOutText;
        setBisState(false, null);
      }
    }

    var bisModal = section.querySelector('[data-bis-modal]');
    if (bisButton && bisModal) {
      var bisForm = bisModal.querySelector('[data-bis-form]');
      var bisEmail = bisModal.querySelector('[data-bis-email]');
      var bisMessage = bisModal.querySelector('[data-bis-message]');
      var bisSubmit = bisModal.querySelector('[data-bis-submit]');
      var bisVariantTitle = bisModal.querySelector('[data-bis-variant-title]');
      var bisCloseEls = bisModal.querySelectorAll('[data-bis-close]');
      var bisLastFocus = null;
      var bisVariantId = '';
      var bisOptions = [];
      var bisProductTitleEl = bisModal.querySelector('.oddit-section-main-product__bis-product-title');

      function bisCompanyId() {
        var configured = (bisModal.getAttribute('data-klaviyo-company-id') || '').trim();
        if (configured) return configured;
        var script = document.querySelector('script[src*="klaviyo.js?company_id="]');
        var match = script ? /company_id=([^&]+)/.exec(script.getAttribute('src')) : null;
        return match ? decodeURIComponent(match[1]) : '';
      }

      function bisSetMessage(text, type) {
        if (!bisMessage) return;
        bisMessage.textContent = text || '';
        bisMessage.hidden = !text;
        bisMessage.classList.toggle('is-error', type === 'error');
        bisMessage.classList.toggle('is-success', type === 'success');
      }

      function bisOpen() {
        if (bisModal.parentElement !== document.body) {
          document.body.appendChild(bisModal);
        }
        bisVariantId = bisButton.getAttribute('data-variant-id') || '';
        bisOptions = currentOptions.slice();
        var variant = variants.filter(function (v) { return String(v.id) === String(bisVariantId); })[0];
        if (bisVariantTitle) {
          var title = variant ? variant.title : bisOptions.join(' / ');
          if (title === 'Default Title') title = '';
          bisVariantTitle.textContent = title;
          bisVariantTitle.hidden = !title;
        }
        bisSubmit.disabled = false;
        bisSetMessage('');
        bisLastFocus = document.activeElement;
        bisModal.hidden = false;
        bisModal.setAttribute('aria-hidden', 'false');
        if (window.OdditScrollLock) window.OdditScrollLock.lock();
        if (bisEmail && typeof bisEmail.focus === 'function') {
          bisEmail.focus({ preventScroll: true });
        }
      }

      function bisClose() {
        if (bisModal.hidden) return;
        bisModal.hidden = true;
        bisModal.setAttribute('aria-hidden', 'true');
        if (window.OdditScrollLock) window.OdditScrollLock.unlock();
        if (bisLastFocus && typeof bisLastFocus.focus === 'function') {
          bisLastFocus.focus({ preventScroll: true });
        }
      }

      bisButton.addEventListener('click', bisOpen);

      bisCloseEls.forEach(function (el) {
        el.addEventListener('click', bisClose);
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !bisModal.hidden) bisClose();
      });

      bisForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = (bisEmail.value || '').trim();
        if (!email || !bisEmail.checkValidity()) {
          bisEmail.setAttribute('aria-invalid', 'true');
          bisSetMessage(bisMessage.getAttribute('data-invalid-text'), 'error');
          bisEmail.focus();
          return;
        }
        bisEmail.removeAttribute('aria-invalid');

        var companyId = bisCompanyId();
        if (!companyId) {
          bisSetMessage(bisMessage.getAttribute('data-error-text'), 'error');
          return;
        }

        bisSubmit.disabled = true;
        bisSetMessage('');

        var profile = {
          data: {
            type: 'profile',
            attributes: { email: email }
          }
        };
        var endpoint;
        var payload;

        if (bisVariantId) {
          endpoint = 'back-in-stock-subscriptions';
          payload = {
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                channels: ['EMAIL'],
                profile: profile
              },
              relationships: {
                variant: {
                  data: {
                    type: 'catalog-variant',
                    id: '$shopify:::$default:::' + bisVariantId
                  }
                }
              }
            }
          };
        } else {
          endpoint = 'events';
          payload = {
            data: {
              type: 'event',
              attributes: {
                properties: {
                  ProductName: bisProductTitleEl ? bisProductTitleEl.textContent.trim() : '',
                  ProductID: bisButton.getAttribute('data-product-id') || '',
                  ProductURL: window.location.origin + window.location.pathname,
                  SelectedOptions: bisOptions.join(' / '),
                  Options: bisOptions
                },
                metric: {
                  data: {
                    type: 'metric',
                    attributes: { name: 'Requested Unavailable Option' }
                  }
                },
                profile: profile
              }
            }
          };
        }

        fetch('https://a.klaviyo.com/client/' + endpoint + '/?company_id=' + encodeURIComponent(companyId), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/vnd.api+json',
            accept: 'application/vnd.api+json',
            revision: '2024-10-15'
          },
          body: JSON.stringify(payload)
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Klaviyo back in stock request failed: ' + res.status);
            bisSetMessage(bisMessage.getAttribute('data-success-text'), 'success');
            bisEmail.value = '';
          })
          .catch(function () {
            bisSubmit.disabled = false;
            bisSetMessage(bisMessage.getAttribute('data-error-text'), 'error');
          });
      });
    }

    /* Step 2: length picker */
    var lengthButtons = section.querySelectorAll('.oddit-section-main-product__length-button[data-length-value]');
    var lengthValueEls = section.querySelectorAll('[data-length-value]:not(.oddit-section-main-product__length-button)');
    var lengthNotesEls = section.querySelectorAll('[data-length-notes]:not(.oddit-section-main-product__length-button)');
    var lengthNotesAnchor = section.querySelector('[data-length-notes]:not(.oddit-section-main-product__length-button)');
    var lengthStepMeta = lengthNotesAnchor
      ? lengthNotesAnchor.closest('.oddit-section-main-product__step-meta')
      : null;

    lengthButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var lengthValue = btn.getAttribute('data-length-value') || '';
        var lengthNotes = btn.getAttribute('data-length-notes') || '';

        lengthButtons.forEach(function (b) {
          b.classList.remove('oddit-section-main-product__length-button--active');
          b.removeAttribute('aria-current');
        });
        btn.classList.add('oddit-section-main-product__length-button--active');
        btn.setAttribute('aria-current', 'true');

        if (lengthIdx >= 0) currentOptions[lengthIdx] = lengthValue;
        applyVariantToUi();

        lengthValueEls.forEach(function (el) { el.textContent = lengthValue; });
        lengthNotesEls.forEach(function (el) { el.textContent = lengthNotes; });
        if (lengthStepMeta) {
          lengthStepMeta.hidden = !lengthValue && !lengthNotes;
        }
      });
    });

    /* ---------- Step 2 "Help me choose" modal ----------
       Opens from the step-2 trigger button. Pills come from product metafield
       custom.length_guide and each carries { look, length, description }. After
       selecting a pill, the recommendation block + CTA update; the green
       "popular" banner uses the is_popular flag baked into the variant JSON.
       The CTA forwards to the matching length-button.click() so all the
       existing variant-update plumbing runs. */
    var helpModal = section.querySelector('[data-step2-help-modal]');
    if (helpModal) {
      var helpTrigger = section.querySelector('[data-step2-help-trigger]');
      var helpCloseEls = helpModal.querySelectorAll('[data-step2-help-close]');
      var helpPills = helpModal.querySelectorAll('[data-step2-help-pill]');
      var helpRecommendation = helpModal.querySelector('[data-step2-help-recommendation]');
      var helpRecommendText = helpModal.querySelector('[data-step2-help-recommend-text]');
      var helpRecommendDesc = helpModal.querySelector('[data-step2-help-recommend-desc]');
      var helpPopular = helpModal.querySelector('[data-step2-help-popular]');
      var helpCta = helpModal.querySelector('[data-step2-help-cta]');
      var helpCtaLabel = helpCta ? helpCta.querySelector('[data-step2-help-cta-label]') : null;

      var helpConfig = {
        ctaTemplate: 'Select {length} Length',
        ctaDefault: 'Select Your Desired Look',
        recommendTemplate: 'We recommend: {length} length'
      };
      var helpConfigEl = section.querySelector('[data-step2-help-config]');
      try {
        if (helpConfigEl) {
          var parsed = JSON.parse(helpConfigEl.textContent);
          if (parsed && typeof parsed === 'object') {
            if (parsed.ctaTemplate) helpConfig.ctaTemplate = parsed.ctaTemplate;
            if (parsed.ctaDefault) helpConfig.ctaDefault = parsed.ctaDefault;
            if (parsed.recommendTemplate) helpConfig.recommendTemplate = parsed.recommendTemplate;
          }
        }
      } catch (e) { /* fall back to defaults */ }

      var helpSelectedLength = '';
      var helpLastFocus = null;

      function helpFormat(tpl, length) {
        return String(tpl || '').replace('{length}', length);
      }

      function helpOpen() {
        /* Teleport to <body> so `position: fixed` is always anchored to the
           viewport, not to the section (which has overflow-x: clip and could
           create containing-block edge cases on mobile). */
        if (helpModal.parentElement !== document.body) {
          document.body.appendChild(helpModal);
        }
        helpLastFocus = document.activeElement;
        helpModal.hidden = false;
        helpModal.setAttribute('aria-hidden', 'false');
        if (window.OdditScrollLock) window.OdditScrollLock.lock();
        var firstClose = helpModal.querySelector('.oddit-section-main-product__help-modal-close');
        if (firstClose && typeof firstClose.focus === 'function') {
          firstClose.focus({ preventScroll: true });
        }
      }

      function helpClose() {
        if (helpModal.hidden) return;
        helpModal.hidden = true;
        helpModal.setAttribute('aria-hidden', 'true');
        if (window.OdditScrollLock) window.OdditScrollLock.unlock();
        if (helpLastFocus && typeof helpLastFocus.focus === 'function') {
          helpLastFocus.focus({ preventScroll: true });
        }
      }

      function helpHandlePill(pill) {
        var length = pill.getAttribute('data-length') || '';
        var description = pill.getAttribute('data-description') || '';
        var isPopular = pill.getAttribute('data-is-popular') === 'true';

        for (var i = 0; i < helpPills.length; i++) {
          var p = helpPills[i];
          var active = p === pill;
          p.classList.toggle('is-active', active);
          p.setAttribute('aria-checked', active ? 'true' : 'false');
        }

        helpSelectedLength = length;

        if (helpRecommendText) helpRecommendText.textContent = helpFormat(helpConfig.recommendTemplate, length);
        if (helpRecommendDesc) helpRecommendDesc.textContent = description;
        if (helpPopular) helpPopular.hidden = !isPopular;
        if (helpRecommendation) helpRecommendation.hidden = false;

        helpCta.disabled = false;
        if (helpCtaLabel) helpCtaLabel.textContent = helpFormat(helpConfig.ctaTemplate, length);
      }

      if (helpTrigger) {
        helpTrigger.addEventListener('click', helpOpen);
      }

      helpCloseEls.forEach(function (el) {
        el.addEventListener('click', helpClose);
      });

      helpPills.forEach(function (pill) {
        pill.addEventListener('click', function () { helpHandlePill(pill); });
      });

      helpCta.addEventListener('click', function () {
        if (helpCta.disabled || !helpSelectedLength) return;
        var targetBtn = null;
        for (var i = 0; i < lengthButtons.length; i++) {
          if (lengthButtons[i].getAttribute('data-length-value') === helpSelectedLength) {
            targetBtn = lengthButtons[i];
            break;
          }
        }
        if (targetBtn) targetBtn.click();
        helpClose();
        var stepEl = section.querySelector('#step-2');
        if (stepEl && typeof stepEl.scrollIntoView === 'function') {
          stepEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !helpModal.hidden) helpClose();
      });
    }

    /* ---------- Step 3 "Compare thickness options" modal ----------
       Read-only modal triggered from the Step 3 helper button. Renders a
       comparison table built from each Thickness variant's custom.weight
       metafield. Mirrors the Step 2 modal's open/close/focus/scroll-lock
       pattern; no CTA writes back to a thickness button. */
    var compareModal = section.querySelector('[data-step3-compare-modal]');
    if (compareModal) {
      var compareTrigger = section.querySelector('[data-step3-compare-trigger]');
      var compareCloseEls = compareModal.querySelectorAll('[data-step3-compare-close]');
      var compareLastFocus = null;

      function compareOpen() {
        /* Teleport to <body> for the same reason as the help modal — see above. */
        if (compareModal.parentElement !== document.body) {
          document.body.appendChild(compareModal);
        }
        compareLastFocus = document.activeElement;
        compareModal.hidden = false;
        compareModal.setAttribute('aria-hidden', 'false');
        if (window.OdditScrollLock) window.OdditScrollLock.lock();
        var firstClose = compareModal.querySelector('.oddit-section-main-product__compare-modal-close');
        if (firstClose && typeof firstClose.focus === 'function') {
          firstClose.focus({ preventScroll: true });
        }
      }

      function compareClose() {
        if (compareModal.hidden) return;
        compareModal.hidden = true;
        compareModal.setAttribute('aria-hidden', 'true');
        if (window.OdditScrollLock) window.OdditScrollLock.unlock();
        if (compareLastFocus && typeof compareLastFocus.focus === 'function') {
          compareLastFocus.focus({ preventScroll: true });
        }
      }

      if (compareTrigger) {
        compareTrigger.addEventListener('click', compareOpen);
      }

      compareCloseEls.forEach(function (el) {
        el.addEventListener('click', compareClose);
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !compareModal.hidden) compareClose();
      });
    }

    /* ---------- Step 1 helper-link content modal ----------
       The Step 1 helper link normally navigates to a separate page
       (section.settings.step1_link_page). Instead we intercept the click and pull
       that page's content into a wide modal that mirrors the Step 2 help modal.
       The content is fetched once on first open (then cached). Falls back to a
       plain link if the fetch fails. The href is a relative store path (page
       picker, not a URL field) so the fetch is always same-origin. */
    var step1Modal = section.querySelector('[data-step1-content-modal]');
    var step1Trigger = section.querySelector('[data-step1-link-trigger]');
    if (step1Modal && step1Trigger) {
      var step1CloseEls = step1Modal.querySelectorAll('[data-step1-content-close]');
      var step1Target = step1Modal.querySelector('[data-step1-content-target]');
      var step1TitleEl = step1Modal.querySelector('[data-step1-content-title]');
      var step1Url = step1Trigger.getAttribute('href') || '';
      var step1LastFocus = null;
      var step1Loaded = false;
      var step1Loading = false;

      function step1Open() {
        /* Teleport to <body> for the same reason as the help modal — see above. */
        if (step1Modal.parentElement !== document.body) {
          document.body.appendChild(step1Modal);
        }
        step1LastFocus = document.activeElement;
        step1Modal.hidden = false;
        step1Modal.setAttribute('aria-hidden', 'false');
        if (window.OdditScrollLock) window.OdditScrollLock.lock();
        var firstClose = step1Modal.querySelector('.oddit-section-main-product__help-modal-close');
        if (firstClose && typeof firstClose.focus === 'function') {
          firstClose.focus({ preventScroll: true });
        }
        step1Load();
      }

      function step1Close() {
        if (step1Modal.hidden) return;
        step1Modal.hidden = true;
        step1Modal.setAttribute('aria-hidden', 'true');
        if (window.OdditScrollLock) window.OdditScrollLock.unlock();
        if (step1LastFocus && typeof step1LastFocus.focus === 'function') {
          step1LastFocus.focus({ preventScroll: true });
        }
      }

      /* Pull the editorial content out of the fetched page. Try the theme's
         default page-content wrapper first, then progressively looser fallbacks. */
      function step1ExtractContent(doc) {
        /* This theme's layout has no <main>/#MainContent — content_for_layout is
           a bare sibling of the header/footer section groups — so the selector
           ladder below would fall through to <body> and drag the header and
           footer into the modal. Take the page template's own sections instead:
           section-group sections render as id="shopify-section-sections--…",
           template sections as id="shopify-section-template--…". */
        var templateSections = doc.querySelectorAll('[id^="shopify-section-template--"]');
        if (templateSections.length) {
          var wrap = doc.createElement('div');
          /* doc is a throwaway parsed document, so moving the nodes is fine. */
          templateSections.forEach(function (el) { wrap.appendChild(el); });
          return wrap;
        }

        var selectors = [
          '.oddit-section-page-content__body',
          'main .rte',
          '.rte',
          '#MainContent',
          'main',
          '[role="main"]'
        ];
        for (var i = 0; i < selectors.length; i++) {
          var el = doc.querySelector(selectors[i]);
          if (el && el.textContent.trim()) return el;
        }
        return doc.body || null;
      }

      function step1ShowFallback() {
        step1Target.textContent = '';
        var p = document.createElement('p');
        p.className = 'oddit-section-main-product__help-modal-content-state';
        p.appendChild(document.createTextNode('We couldn’t load this content. '));
        var a = document.createElement('a');
        a.href = step1Url;
        a.textContent = 'Open the page instead';
        p.appendChild(a);
        p.appendChild(document.createTextNode('.'));
        step1Target.appendChild(p);
      }

      function step1Load() {
        if (step1Loaded || step1Loading || !step1Target) return;
        if (!step1Url || step1Url.charAt(0) === '#') return;
        step1Loading = true;
        step1Target.innerHTML = '<p class="oddit-section-main-product__help-modal-content-state">Loading…</p>';
        fetch(step1Url, { credentials: 'same-origin' })
          .then(function (res) {
            if (!res.ok) throw new Error('HTTP ' + res.status);
            return res.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var content = step1ExtractContent(doc);
            if (!content) throw new Error('No content');
            if (step1TitleEl) {
              var heading = doc.querySelector('.oddit-section-page-content__title, main h1, .rte h1, h1');
              var t = heading ? heading.textContent.trim() : (doc.title || '').trim();
              if (t) step1TitleEl.textContent = t;
            }
            step1Target.innerHTML = content.innerHTML;
            /* Injected nodes are invisible by default and stay that way: the
               global reveal IntersectionObserver only watches elements that
               existed when it ran, so .oddit-reveal never gets .is-visible, and
               any scraped .shopify-section wrapper never gets
               .oddit-section-active. Both are opacity:0 in oddit-interactions.css,
               so clear them by hand here. */
            step1Target.querySelectorAll('.oddit-reveal').forEach(function (el) {
              el.classList.add('is-visible');
            });
            step1Target.querySelectorAll('.shopify-section').forEach(function (el) {
              el.classList.add('oddit-section-active');
            });
            step1Loaded = true;
          })
          .catch(function () {
            step1ShowFallback();
          })
          .then(function () { step1Loading = false; });
      }

      step1Trigger.addEventListener('click', function (e) {
        e.preventDefault();
        step1Open();
      });

      step1CloseEls.forEach(function (el) {
        el.addEventListener('click', step1Close);
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !step1Modal.hidden) step1Close();
      });
    }

    /* Step 3: thickness picker */
    var thicknessButtons = section.querySelectorAll('.oddit-section-main-product__thickness-button[data-thickness-value]');
    var thicknessWeightEls = section.querySelectorAll('[data-thickness-weight]:not(.oddit-section-main-product__thickness-button)');
    var thicknessNotesEls = section.querySelectorAll('[data-thickness-notes]:not(.oddit-section-main-product__thickness-button)');
    var thicknessSummaryEls = section.querySelectorAll('[data-thickness-summary]:not(.oddit-section-main-product__thickness-button)');
    var thicknessNotesAnchor = section.querySelector('[data-thickness-notes]:not(.oddit-section-main-product__thickness-button)');
    var thicknessStepMeta = thicknessNotesAnchor
      ? thicknessNotesAnchor.closest('.oddit-section-main-product__step-meta')
      : null;

    thicknessButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var thicknessValue = btn.getAttribute('data-thickness-value') || '';
        var weight = btn.getAttribute('data-thickness-weight') || '';
        var notes = btn.getAttribute('data-thickness-notes') || '';
        var summary = btn.getAttribute('data-thickness-summary') || '';

        thicknessButtons.forEach(function (b) {
          b.classList.remove('oddit-section-main-product__thickness-button--active');
          b.removeAttribute('aria-current');
        });
        btn.classList.add('oddit-section-main-product__thickness-button--active');
        btn.setAttribute('aria-current', 'true');

        if (thicknessIdx >= 0) currentOptions[thicknessIdx] = thicknessValue;
        applyVariantToUi();

        thicknessWeightEls.forEach(function (el) { el.textContent = weight; });
        thicknessNotesEls.forEach(function (el) { el.textContent = notes; });
        thicknessSummaryEls.forEach(function (el) { el.textContent = summary; });
        if (thicknessStepMeta) {
          thicknessStepMeta.hidden = !weight && !notes;
        }
      });
    });

    /* ---------- UGC carousel ---------- */
    var ugcCarousel = section.querySelector('.oddit-section-main-product__ugc-carousel');
    var ugcArrows = section.querySelectorAll('.oddit-section-main-product__ugc-arrow');
    var ugcDots = section.querySelectorAll('.oddit-section-main-product__ugc-dot');
    var ugcCards = section.querySelectorAll('.oddit-section-main-product__ugc-card');

    if (ugcCarousel && !ugcCarousel.dataset.ugcInit) {
      ugcCarousel.dataset.ugcInit = '1';

      var ugcDotsWrap = section.querySelector('.oddit-section-main-product__ugc-dots');
      var ugcPagination = section.querySelector('.oddit-section-main-product__ugc-pagination');
      var bleedMQ = window.matchMedia('(min-width: 990px)');

      /* Size the track so its right edge meets the viewport edge (right-bleed)
         while still being narrower than its content, so it stays scrollable. */
      var updateBleed = function () {
        ugcCarousel.style.width = '';
        if (bleedMQ.matches) {
          var left = ugcCarousel.getBoundingClientRect().left;
          var vw = document.documentElement.clientWidth;
          ugcCarousel.style.width = Math.max(0, vw - left) + 'px';
        }
      };

      /* A "page" is one track-width of scrolling — dots reflect how many
         scroll positions / clicks exist, not the card count. Round (not ceil)
         so a sub-half-page tail collapses into the previous page; otherwise
         we'd show a phantom final dot whose target is barely different from
         the previous one. Floor at 2 when scrollable so the user can always
         dot-jump start/end. */
      var metrics = function () {
        var clientW = ugcCarousel.clientWidth;
        var maxScroll = Math.max(0, ugcCarousel.scrollWidth - clientW);
        var padRight = parseFloat(getComputedStyle(ugcCarousel).paddingRight) || 0;
        /* only a real card overflow counts as "a carousel" — ignore the
           trailing end-padding so a set that fits stays a static row */
        var scrollable = maxScroll > padRight + 1;
        var pages = clientW > 0 && scrollable
          ? Math.max(2, Math.round(ugcCarousel.scrollWidth / clientW))
          : 1;
        return { clientW: clientW, maxScroll: maxScroll, scrollable: scrollable, pages: pages };
      };

      var activePage = function (m) {
        if (!m.scrollable) return 0;
        if (ugcCarousel.scrollLeft >= m.maxScroll - 1) return m.pages - 1;
        return Math.max(0, Math.min(m.pages - 1, Math.round(ugcCarousel.scrollLeft / m.clientW)));
      };

      var syncDots = function () {
        var m = metrics();
        var idx = activePage(m);
        if (ugcDotsWrap) {
          var dots = ugcDotsWrap.children;
          for (var i = 0; i < dots.length; i++) {
            dots[i].classList.toggle('oddit-section-main-product__ugc-dot--active', i === idx);
          }
        }
        if (ugcArrows.length === 2) {
          ugcArrows[0].disabled = !m.scrollable || idx <= 0;
          ugcArrows[1].disabled = !m.scrollable || idx >= m.pages - 1;
        }
      };

      var renderDots = function () {
        var m = metrics();
        /* Hide the whole control when there's nothing to scroll */
        if (ugcPagination) ugcPagination.style.display = m.pages <= 1 ? 'none' : '';
        if (!ugcDotsWrap) return;
        ugcDotsWrap.innerHTML = '';
        for (var i = 0; i < m.pages; i++) {
          var dot = document.createElement('span');
          dot.className = 'oddit-section-main-product__ugc-dot';
          dot.style.cursor = 'pointer';
          (function (idx) {
            dot.addEventListener('click', function () {
              var mm = metrics();
              var target = idx >= mm.pages - 1 ? mm.maxScroll : idx * mm.clientW;
              ugcCarousel.scrollTo({ left: target, behavior: 'smooth' });
            });
          })(i);
          ugcDotsWrap.appendChild(dot);
        }
        syncDots();
      };

      ugcCarousel.addEventListener('scroll', syncDots);

      /* Arrow click navigates dot-to-dot (not raw scrollBy clientWidth) so the
         landing position always matches a dot target. With the round-based
         pages count, scrolling by exactly clientWidth could otherwise land
         between dots and de-sync the active indicator from the arrows. */
      if (ugcArrows.length === 2) {
        ugcArrows[0].addEventListener('click', function () {
          var m = metrics();
          var idx = activePage(m);
          if (idx <= 0) return;
          var prevIdx = idx - 1;
          var target = prevIdx <= 0 ? 0 : prevIdx * m.clientW;
          ugcCarousel.scrollTo({ left: target, behavior: 'smooth' });
        });
        ugcArrows[1].addEventListener('click', function () {
          var m = metrics();
          var idx = activePage(m);
          if (idx >= m.pages - 1) return;
          var nextIdx = idx + 1;
          var target = nextIdx >= m.pages - 1 ? m.maxScroll : nextIdx * m.clientW;
          ugcCarousel.scrollTo({ left: target, behavior: 'smooth' });
        });
      }

      /* Pointer drag-to-scroll (desktop / mouse; touch uses native scroll).
         Only engage when the pointer starts on text content (quote/username) —
         starting on a video frame leaves it free to receive hover-play + click. */
      var isDown = false, startX = 0, startScroll = 0, moved = false;
      ugcCarousel.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        if (e.target.closest('.oddit-section-main-product__ugc-video-frame')) return;
        isDown = true;
        moved = false;
        startX = e.clientX;
        startScroll = ugcCarousel.scrollLeft;
        ugcCarousel.classList.add('is-dragging');
      });
      ugcCarousel.addEventListener('pointermove', function (e) {
        if (!isDown) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 3) moved = true;
        ugcCarousel.scrollLeft = startScroll - dx;
      });
      var endDrag = function () {
        if (!isDown) return;
        isDown = false;
        ugcCarousel.classList.remove('is-dragging');
      };
      ugcCarousel.addEventListener('pointerup', endDrag);
      ugcCarousel.addEventListener('pointercancel', endDrag);
      ugcCarousel.addEventListener('pointerleave', endDrag);
      /* Swallow the click that follows a drag so it doesn't fire card buttons */
      ugcCarousel.addEventListener('click', function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      }, true);

      /* ---------- UGC video hover-play (mirrors oddit-section-ugc-carousel) ----------
         Hover plays a muted, controls-free 5-second preview loop; click promotes
         the video to full playback with native controls; on `ended` we reset so
         the next hover starts fresh. Hover listeners live on the FRAME so the
         play-icon overlay can't block them. The frame toggles `is-playing` so
         the overlay can fade out while the preview runs. */
      var UGC_PREVIEW_LIMIT_S = 5;
      ugcCarousel.querySelectorAll('[data-ugc-frame]').forEach(function (frameEl) {
        if (frameEl.dataset.ugcFrameInitialized === 'true') return;
        frameEl.dataset.ugcFrameInitialized = 'true';
        var videoEl = frameEl.querySelector('[data-ugc-video]');
        if (!videoEl) return;

        var previewMode = true;
        function safePlay() {
          var p = videoEl.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        }
        function rewind() {
          try { videoEl.currentTime = 0; } catch (e) {}
        }

        frameEl.addEventListener('mouseenter', function () {
          if (!previewMode) return;
          videoEl.muted = true;
          videoEl.controls = false;
          frameEl.classList.add('is-playing');
          rewind();
          safePlay();
        });
        frameEl.addEventListener('mouseleave', function () {
          if (!previewMode) return;
          videoEl.pause();
          frameEl.classList.remove('is-playing');
          rewind();
        });
        videoEl.addEventListener('timeupdate', function () {
          if (!previewMode) return;
          if (videoEl.currentTime >= UGC_PREVIEW_LIMIT_S) {
            rewind();
            if (videoEl.paused) safePlay();
          }
        });
        frameEl.addEventListener('click', function () {
          if (!previewMode) return;
          previewMode = false;
          videoEl.muted = false;
          videoEl.controls = true;
          frameEl.classList.add('is-playing');
          rewind();
          safePlay();
        });
        videoEl.addEventListener('ended', function () {
          previewMode = true;
          videoEl.controls = false;
          videoEl.muted = true;
          frameEl.classList.remove('is-playing');
          try { videoEl.load(); } catch (e) {}
        });
      });

      var refresh = function () {
        updateBleed();
        renderDots();
      };
      refresh();
      window.addEventListener('resize', refresh);
    }

    /* ---------- Add to Cart button ---------- */
    var atcButton = section.querySelector('[data-add-to-cart]');
    if (atcButton) {
      atcButton.addEventListener('click', function (e) {
        if (!window.OdditCartDrawer) return;

        var variantId = Number(atcButton.getAttribute('data-variant-id'));
        if (!variantId) return;

        var quantity = Number(atcButton.getAttribute('data-quantity')) || 1;

        var restWidth = atcButton.getBoundingClientRect().width;
        atcButton.style.minWidth = restWidth + 'px';

        atcButton.disabled = true;
        atcButton.classList.add('is-loading');
        atcButton.setAttribute('aria-busy', 'true');

        window.OdditCartDrawer.addToCart(variantId, quantity)
          .then(function () {
            window.OdditCartDrawer.open();
          })
          .finally(function () {
            atcButton.disabled = false;
            atcButton.classList.remove('is-loading');
            atcButton.removeAttribute('aria-busy');
            atcButton.style.minWidth = '';
          });
      });
    }
  }

  function destroySection() {
    /* No persistent timers/observers to clean up */
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function () {
    destroySection();
  });
})();